import type { Engagement, EngagementTemplate } from '…/app/w/workspace/engagements/Engagement.d.ts';


export const templatesState= new Map<Engagement['id'], Set<EngagementTemplate>>();
